export type NewsCategory =
  | '联盟动态'
  | '战略发布'
  | '项目里程碑'
  | '战略合作'
  | '技术发布'
  | '企业动态'
  | '荣誉赛事';

export interface NewsItem {
  id: number;
  category: NewsCategory;
  title: string;
  excerpt: string;
  cover: string;
  date: string;
  tag?: string;
  content: string[];
}

export const newsCategories: Array<'全部' | NewsCategory> = [
  '全部',
  '联盟动态',
  '战略发布',
  '项目里程碑',
  '战略合作',
  '技术发布',
  '企业动态',
  '荣誉赛事',
];

export const newsItems: NewsItem[] = [
  {
    id: 0,
    category: '联盟动态',
    title: '作为联盟核心成员深度参与全国OPC社区网络建设',
    excerpt: '协同石家庄、廊坊、张家口、雄安新区、太原、临沂、唐山等地社区运营，推进县域AI+OPC生态协同落地。',
    cover: 'https://readdy.ai/api/search-image?query=China%20regional%20community%20network%20collaboration%20map%2C%20AI%20ecosystem%20nodes%20connected%2C%20dark%20background%20with%20golden%20lines%2C%20professional%20corporate%20news%20visual%2C%20no%20text&width=600&height=400&seq=news-opc-alliance-20&orientation=landscape',
    date: '2026-08-12',
    tag: '最新',
    content: [
      '作为冯全普·县域AI+OPC联盟核心成员单位，公司深度参与全国OPC社区网络建设，推动跨区域协同机制落地。',
      '通过“人才培养-项目实训-创业孵化-商业变现”链路，公司与多地社区形成常态化联动，持续服务县域数字内容产业发展。',
    ],
  },
  {
    id: 1,
    category: '战略发布',
    title: '晋铧叙梦正式启动"山西故事文化出海计划"',
    excerpt: '以山西117个县域文化资源为内容源，以AI数字光影内容为载体，携手图兰朵布局美国、东南亚等海外市场。',
    cover: 'https://readdy.ai/api/search-image?query=Global%20cultural%20communication%20visualization%2C%20Chinese%20culture%20going%20global%20concept%2C%20world%20map%20with%20cultural%20connection%20lines%2C%20warm%20gold%20accents%20on%20dark%20background%2C%20professional%20corporate%20news%20style%2C%20no%20text&width=600&height=400&seq=news-overseas-14&orientation=landscape',
    date: '2026-07-10',
    tag: '最新',
    content: [
      '公司以山西117个县域文化资源为内容源，依托AI工业化平台打造多语种内容样片，推动三晋文化数字化、国际化传播。',
      '首期聚焦美国与东南亚市场，联合海外合作方构建本土化分发与运营机制，提升文化内容触达与转化效率。',
    ],
  },
  {
    id: 2,
    category: '项目里程碑',
    title: '山西非遗文化数字资产库1.0正式建成',
    excerpt: '历时数月系统化整理与数字化研发，覆盖117个县域的非遗文化资源已完成数字化采集、归档与云端入库。',
    cover: 'https://readdy.ai/api/search-image?query=Digital%20archive%20completion%20celebration%2C%20Chinese%20cultural%20heritage%20database%20visualization%2C%20warm%20golden%20accents%2C%20professional%20tech%20achievement%20style%2C%20dark%20background%2C%20no%20text&width=600&height=400&seq=news-asset-db-15&orientation=landscape',
    date: '2026-06-28',
    content: [
      '该资产库覆盖历史传说、非遗技艺、古建文物、文旅地标等关键内容，为后续内容生产与城市IP运营提供统一底层数据支撑。',
      '1.0版本建成后将持续按县域维度迭代更新，提升资源检索、复用与跨项目协同能力。',
    ],
  },
  {
    id: 3,
    category: '战略合作',
    title: '携手舌尖味道达成全国独家运营战略合作',
    excerpt: '晋铧叙梦与舌尖味道品牌正式签署全国独家运营战略合作协议，三大IP主题直播间将陆续上线。',
    cover: 'https://readdy.ai/api/search-image?query=Business%20partnership%20signing%20ceremony%20visualization%2C%20food%20brand%20collaboration%2C%20warm%20golden%20lighting%2C%20professional%20corporate%20event%20style%2C%20dark%20background%2C%20no%20text&width=600&height=400&seq=news-food-partner-16&orientation=landscape',
    date: '2026-06-20',
    content: [
      '双方将围绕品牌文化叙事、内容矩阵搭建与全渠道流量运营开展深度合作，推动传统品牌实现数字化增长。',
      '合作将重点探索“内容赋能+商业转化”双驱动模式，打造可复制的行业样板。',
    ],
  },
  {
    id: 4,
    category: '技术发布',
    title: '自研AI短剧/漫剧工业化SOP生产标准平台落地',
    excerpt: '平台覆盖剧本创作、分镜设计、AI绘画、仿真人制作、剪辑配音全流程，实现月产千集级量产能力。',
    cover: 'https://readdy.ai/api/search-image?query=AI%20technology%20platform%20launch%20visualization%2C%20automated%20content%20production%20pipeline%2C%20futuristic%20tech%20with%20Chinese%20cultural%20elements%2C%20dark%20background%2C%20professional%20style%2C%20no%20text&width=600&height=400&seq=news-ai-platform-17&orientation=landscape',
    date: '2026-05-15',
    content: [
      '平台以标准化SOP串联创意、制作与交付全流程，显著提升内容生产的稳定性与规模化能力。',
      '在技术迭代中，公司将持续结合联盟技术中台资源优化效率、成本与质量表现。',
    ],
  },
  {
    id: 5,
    category: '企业动态',
    title: '晋铧叙梦迁址榆次巨燕商务广场',
    excerpt: '公司正式迁址晋中市榆次区巨燕商务广场，办公面积扩大，团队规模持续增长。',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20office%20building%20exterior%20with%20Chinese%20corporate%20headquarters%20vibe%2C%20golden%20hour%20lighting%2C%20professional%20business%20district%2C%20dark%20modern%20aesthetic%2C%20no%20text&width=600&height=400&seq=news-office-move-18&orientation=landscape',
    date: '2026-04-10',
    content: [
      '新办公环境将更好支撑内容生产、项目管理和人才培养协同，匹配公司规模化发展需求。',
      '迁址后公司将继续深耕县域文化数字化，推进“山西样板”向全国复制。',
    ],
  },
  {
    id: 6,
    category: '荣誉赛事',
    title: '成为知乎官方战略合作伙伴',
    excerpt: '晋铧叙梦正式成为知乎官方战略合作伙伴，双方将在文化内容创作与知识传播领域展开深度合作。',
    cover: 'https://readdy.ai/api/search-image?query=Strategic%20partnership%20announcement%20visualization%2C%20digital%20content%20platform%20collaboration%2C%20professional%20tech%20partnership%20style%2C%20dark%20background%2C%20no%20text&width=600&height=400&seq=news-zhihu-partner-19&orientation=landscape',
    date: '2026-01-20',
    content: [
      '该合作将进一步拓展公司在知识内容与文化传播领域的场景能力，提升项目协同效率与内容影响力。',
      '公司将依托平台生态持续输出优质文化数字内容，增强品牌公信力与行业影响力。',
    ],
  },
];

